import { useEffect, useMemo, useState } from 'react';
import PageHeading from 'components/heading/index';
import ManageProcessors from './tabs/manageProcessors/index';
import FeatureFlags from './tabs/featureFlags/index';
import usePaymentConfig from 'state/paymentConfig/hooks/usePaymentConfig';
import OtherConfigs from './tabs/otherConfigs/index';
import { Tabs, TabsList, TabsTrigger, TabsContent } from 'components/ui/tabs';
import { AdminConfigurationTab } from 'types/settings/internalConfig';

const ConfigurationSettings = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState(
    AdminConfigurationTab.MANAGE_PROCESSORS
  );

  const {
    toFetchAllPaymentSolutions,
    resetPaymentDeviceList,
  } = usePaymentConfig();

  const TABS = useMemo(
    () => [
      {
        value: AdminConfigurationTab.MANAGE_PROCESSORS,
        label: 'Manage processors',
        render: () => <ManageProcessors />,
      },
      {
        value: AdminConfigurationTab.FEATURE_FLAGS,
        label: 'Manage Feature Flags',
        render: () => <FeatureFlags />,
      },
      {
        value: AdminConfigurationTab.OTHER_CONFIGS,
        label: 'Other Configs',
        render: () => <OtherConfigs />,
      },
    ],
    []
  );

  useEffect(() => {
    toFetchAllPaymentSolutions();
  }, []);

  const toggleTab = (tabValue: string) => {
    resetPaymentDeviceList();
    setActiveTab(tabValue as AdminConfigurationTab);
  };

  return (
    <div className="rounded-lg">
      <PageHeading heading="Admin configurations" overrideContainerClass />

      <Tabs value={activeTab} onValueChange={toggleTab} className="w-full">
        <div className="border-b border-gray-blue-10">
          <TabsList className="h-auto p-0 bg-transparent rounded-none border-0 w-full justify-start">
            {TABS.map((tab) => (
              <TabsTrigger
                key={tab.value}
                value={tab.value}
                className="first:ml-0 mx-3 px-0 w-fit py-3 rounded-none border-b-2 border-transparent data-[state=active]:border-treez-green data-[state=active]:text-gray-blue-80 data-[state=active]:bg-transparent text-gray-blue-60 hover:text-gray-blue-80 hover:border-gray-blue-20 data-[state=active]:shadow-none"
              >
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>

        <div className="py-4">
          {TABS.map((tab) => (
            <TabsContent key={tab.value} value={tab.value} className="mt-0">
              {tab.render()}
            </TabsContent>
          ))}
        </div>
      </Tabs>
    </div>
  );
};

export default ConfigurationSettings;
